import { CookiesStore, CookiesActions } from './types';

export const defaultState: CookiesStore = {
  enabledCookieGroups: {
    initial: false,
    targeting: false,
    performance: false,
    functional: false,
  },
};

const reducer = (
  state: CookiesStore = defaultState,
  action: { type: CookiesActions; payload?: any }
): CookiesStore => {
  switch (action.type) {
    case CookiesActions.SetEnabledCookieGroups: {
      return {
        ...state,
        enabledCookieGroups: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
